import Layout from "@/layout";

const shoporderRouter = {
  path: "/shoporder",
  component: Layout,
  redirect: "/shoporder/order",
  name: "shoporder",
  meta: {
    title: "商城订单",
    icon: "clipboard"
  },
  children: [
    {
      path: "order",
      component: () => import("@/views/shoporder/order/index"),
      name: "order",
      meta: { title: "商品订单", icon: "" }
    },
    {
      path: "review/product",
      component: () => import("@/views/shoporder/review/product"),
      name: "reviewProduct",
      meta: { title: "商品评论", icon: "" }
    },
    {
      path: "review/homemaking",
      component: () => import("@/views/shoporder/review/homemaking"),
      name: "reviewHomemaking",
      meta: { title: "家政评论", icon: "" }
    },
    {
      path: "refund",
      component: () => import("@/views/shoporder/refund/index"),
      name: "refund",
      meta: { title: "退款售后", icon: "" }
    },
    {
      path: "refundDetail/:id?",
      component: () => import("@/views/shoporder/refundDetail"),
      name: "refundDetail",
      meta: {
        title: "退款详情",
        icon: "",
        noCache: true,
        activeMenu: `/shoporder/refund`,
        parentPath: `/shoporder/refund`
      },
      hidden: true
    }
  ]
};

export default shoporderRouter;
